import { parseTime } from '@/filters'
import { fmtSize, fmtSeconds } from '@com/utils/data-format'
import { applicableOptions, applicableResourcesOptions } from './option'
import type { TableColumnType, CheckedGroupsType } from './type'
import { TabsType } from './enums'
import { skeletonOptions, showStatusOption, auditStatusOption } from './option'
import type { fileListType } from '@/api/public_resource/type'
import { getFileExtension } from '@com/utils/file'

// 基本信息
export const dataBaseInformation: TableColumnType[] = [
  {
    label: '资源id',
    prop: 'id',
    disabled: true,
    width: 60,
    align: 'center',
  },
  {
    label: '资源名称',
    prop: 'name',
    disabled: true,
    slot: 'name',
  },
  {
    label: '缩略图',
    prop: 'thumb_url',
    slot: 'thumb_url',
    align: 'center',
  },
  {
    label: '描述',
    prop: 'description',
    width: 150,
    align: 'center',
    showOverflowTooltip: true,
  },
  {
    label: '资源来源',
    prop: 'source',
    align: 'center',
    params: {
      innerHTML(o: any): string {
        const { row } = o
        return row.source === 1 ? '内部' : '外部购买'
      },
    },
  },
  {
    label: '创建人',
    prop: 'creator_name',
    align: 'center',
  },
  {
    label: '创建时间',
    prop: 'created_time',
    align: 'center',
    width: 150,
    params: {
      innerHTML(o: any): string {
        const { row } = o
        return row.created_time
          ? parseTime(row.created_time, '{y}-{m}-{d} {h}:{i}:{s}')
          : '-'
      },
    },
  },
  {
    label: '修改人',
    prop: 'modifier_name',
    align: 'center',
    params: {
      innerHTML(o: any): string {
        const { row } = o
        return row.modifier_name || row.admin_name || '-'
      },
    },
  },
  {
    label: '更新时间',
    prop: 'updated_time',
    sortable: 'updated_time',
    width: 150,
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.updated_time
          ? parseTime(row.updated_time, '{y}-{m}-{d} {h}:{i}:{s}')
          : '-'
      },
    },
  },
]

// 所有资源属性
const resourceInformation: TableColumnType[] = [
  {
    label: '资源类型',
    prop: 'type',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        switch (row.type) {
          case TabsType.ALL:
            return '全部'
          case TabsType.VIDEO:
            return '视频'
          case TabsType.PICTURE:
            return '图片'
          case TabsType.GRAPH:
            return '动图'
          case TabsType.AUDIO:
            return '音频'
          case TabsType.PARTICLE:
            return '粒子'
          case TabsType.FONT:
            return '字体'
          case TabsType.KEEL:
            return '龙骨'
          case TabsType.FLOWERWORD:
            return '花字'
          case TabsType.TRANSITION:
            return '转场'
          case TabsType.FILTER:
            return '滤镜'
          case TabsType.ANIMATION:
            return '动画'
          case TabsType.PRESETS:
            return '预设'
          case TabsType.FRAGMENT:
            return '片段'
          case TabsType.MODEL:
            return '模型'
          case TabsType.ACTION:
            return '动作'
          default:
            return '-'
        }
      },
    },
  },
  {
    label: '格式fomat',
    prop: 'format',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.file_meta.format
      },
    },
  },
  {
    label: '大小byte_size',
    prop: 'file_size',
    align: 'center',
    width: 100,
    params: {
      innerHTML(o: any) {
        const { row } = o
        return fmtSize(row.file_meta.file_size)
      },
    },
  },
  {
    label: '尺寸size',
    prop: 'width',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.file_meta.width || row.file_meta.height
          ? `${row.file_meta.width}*${row.file_meta.height}`
          : '-'
      },
    },
  },
  {
    label: '比率ratio',
    prop: 'ratio',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.file_meta.ratio || '-'
      },
    },
  },
  {
    label: '时长',
    prop: 'duration',
    align: 'center',
    width: 100,
    params: {
      innerHTML(o: any) {
        const { row } = o
        if (row.file_meta && row.file_meta.duration) {
          return fmtSeconds(row.file_meta.duration / 1000)
        } else if (row.duration) {
          return fmtSeconds(row.duration / 1000)
        }
        return '-'
      },
    },
  },
  {
    label: '码率bit_rate',
    prop: 'bit_rate',
    align: 'center',
    width: 100,
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.file_meta.bit_rate || '-'
      },
    },
  },
  {
    label: '帧率fps',
    prop: 'fps',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.file_meta.fps || '-'
      },
    },
  },
  {
    label: '帧数',
    prop: 'frames',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.file_meta.frames || '-'
      },
    },
  },
  {
    label: '实现方式',
    prop: 'realize_method',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        switch (row.realize_method) {
          case 1:
            return '2D PS粒子'
          case 2:
            return '3D Unity粒子'
          case 3:
            return '3D laya粒子'
          case 4:
            return '2D laya粒子'
          case 5:
            return '3D cocos粒子'
          default:
            return '-'
        }
      },
    },
  },
  {
    label: '语种',
    prop: 'languages',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.languages ? '原语言,' + row.languages : '原语言'
      },
    },
  },
  {
    label: '花字类型',
    prop: 'flower_word_type',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        switch (row.flower_word_type) {
          case 1:
            return '花字'
          case 2:
            return '字体预设'
          default:
            return '-'
        }
      },
    },
  },
  {
    label: '适用资源',
    prop: 'adapter_resources',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        const resource: string[] = []
        const array =
          row.adapter_resources && row.adapter_resources.split(',').map(Number)

        if (array) {
          applicableResourcesOptions.map((item) => {
            if (array.includes(item.value)) {
              resource.push(item.label)
            }
          })
          if (resource.length) {
            return resource.toString().replace(/,/g, ' ')
          }

          return '-'
        }

        return '-'
      },
    },
  },
  {
    label: '动画类型',
    prop: 'cartoon_type',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        switch (row.cartoon_type) {
          case 1:
            return '入场'
          case 2:
            return '出场'
          case 3:
            return '组合'
          case 4:
            return '循环'
          default:
            return '-'
        }
      },
    },
  },
  {
    label: '骨骼类型',
    prop: 'skeleton_type',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        const i = skeletonOptions.find((item) => {
          return item.value === row.skeleton_type
        }) || { label: '-' }
        return i.label
      },
    },
  },
  {
    label: '模型基础信息',
    prop: 'model_basic_info',
    align: 'center',
    width: 120,
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.type === TabsType.MODEL
          ? `面数（三角面）:${row.file_meta.face_count}; 顶点数:${
              row.file_meta.vertex_count
            }; 骨骼数:${row.file_meta.skeleton_count}; 文件格式:${getFormat(
              row.file_list,
            )};`
          : '-'
      },
    },
  },
  {
    label: '动作基础信息',
    prop: 'action_basic_info',
    align: 'center',
    width: 120,
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.type === TabsType.ACTION
          ? `帧数:${row.file_meta.frames}; 帧率:${row.file_meta.fps}; `
          : '-'
      },
    },
  },
  {
    label: '尺寸',
    prop: 'ratios',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        return row.ratios
      },
    },
  },
  {
    label: '视频项目ID',
    prop: 'src_project_id',
    align: 'center',
    width: 120,
  },
  {
    label: '提交审核时间',
    prop: 'audit_time',
    align: 'center',
    params: {
      innerHTML(o: any): string {
        const { row } = o
        return row.audit_time
          ? parseTime(row.audit_time, '{y}-{m}-{d} {h}:{i}:{s}')
          : '-'
      },
    },
  },
  {
    label: '审核状态',
    prop: 'audit_status',
    align: 'center',
    width: 120,
    params: {
      innerHTML(o: any) {
        const { row } = o

        const temp = auditStatusOption.find(
          (item) => item.value === row.audit_status,
        )
        if (temp) {
          return temp.label
        }
        return '-'
      },
    },
  },
  {
    label: '上架时间',
    prop: 'show_on_time',
    align: 'center',
    params: {
      innerHTML(o: any): string {
        const { row } = o
        return row.show_on_time
          ? parseTime(row.show_on_time, '{y}-{m}-{d} {h}:{i}:{s}')
          : '-'
      },
    },
  },
  {
    label: '使用次数',
    prop: 'use_count',
    align: 'center',
  },
  {
    label: '换肤编辑使用数',
    prop: 'pt_use_count',
    align: 'center',
  },
  {
    label: '自由编辑使用数',
    prop: 'ps_use_count',
    align: 'center',
  },
  {
    label: '导出视频数',
    prop: 've_use_count',
    align: 'center',
  },
  {
    label: '审核拒绝原因',
    prop: 'remake',
    align: 'center',
  },
]

function getFormat(file_list: fileListType[]) {
  const formatList = (file_list || []).filter((file: fileListType) => {
    return (
      getFileExtension(file.name) === 'glb' ||
      getFileExtension(file.name) === 'gltf'
    )
  })
  if (formatList.length) {
    return getFileExtension(formatList[0]!.name)
  }
  return '-'
}

// 资源状态
export const dataStatusInformation: TableColumnType[] = [
  {
    label: '上架状态',
    prop: 'show_status',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        const temp = showStatusOption.find(
          (item) => item.value === row.show_status,
        )
        if (temp) {
          return temp.label
        }
        return '-'
      },
    },
  },
  {
    label: '是否公开',
    prop: 'public',
    align: 'center',
    width: 120,
    params: {
      innerHTML(o: any) {
        const { row } = o
        if (row.public) {
          return row.public === 1 ? '是，外部可用' : '否，仅内部使用'
        } else if (row.only_inner !== '') {
          return row.only_inner === 1 ? '否，仅内部使用' : '是，外部可用'
        }
        return '-'
      },
    },
  },
  {
    label: '版权状态',
    prop: 'copyright',
    align: 'center',
    width: 170,
    params: {
      innerHTML(o: any) {
        const { row } = o
        switch (row.copyright) {
          case 1:
            return '无商业版权'
          case 2:
            return '有商业版权但无额外授权'
          case 3:
            return '有商业版权且有额外授权'
          case 4:
            return '未知'
          case 5:
            return '原创'
          default:
            return '-'
        }
      },
    },
  },
  {
    label: '应用范围',
    prop: 'applicable_tools',
    align: 'center',
    params: {
      innerHTML(o: any) {
        const { row } = o
        const resource: string[] = []
        const array =
          row.applicable_tools && row.applicable_tools.split(',').map(Number)

        if (array) {
          applicableOptions.map((item) => {
            if (array.includes(item.value)) {
              resource.push(item.label)
            }
          })
          if (resource.length) {
            return resource.toString().replace(/,/g, ' ')
          }
          return '-'
        }

        return '-'
      },
    },
  },
]
// 资源标签
export const dataLabelInformation: TableColumnType[] = [
  {
    label: '标签',
    prop: 'tag_names',
    align: 'center',
  },
  {
    label: 'ai 标签',
    prop: 'ai_tag_names',
    align: 'center',
  },
]

// 默认列
export const checkedColumnGroups = {
  baseGroups: ['thumb_url', 'id', 'name', 'modifier_name', 'updated_time'],
  resourceGroups: [
    'type',
    'realize_method',
    'flower_word_type',
    'adapter_resources',
    'cartoon_type',
    've_use_count',
    'pt_use_count',
    'ps_use_count',
  ],
  statusGroups: ['public', 'show_status'],
  labelGroups: ['tag_names'],
}

// 片段
export const fragmentProperties = [
  'duration',
  'ratios',
  'languages',
  'src_project_id',
  'audit_time',
  'audit_status',
  'show_on_time',
  'use_count',
  'remake',
]

// tab类型下的自定义展示列
export function customColumns(val: number): TableColumnType[] {
  let resourceProperties: TableColumnType[] = []

  // 视频
  const videoProperties = [
    'type',
    'format',
    'file_size',
    'width',
    'ratio',
    'duration',
    'bit_rate',
    'fps',
    'pt_use_count',
    'ps_use_count',
    've_use_count',
  ]
  // 图片
  const pictureProperties = [
    'type',
    'format',
    'file_size',
    'width',
    'ratio',
    'pt_use_count',
    'ps_use_count',
    've_use_count',
  ]
  // 动图
  const graphProperties = [
    'type',
    'format',
    'file_size',
    'width',
    'ratio',
    'frames',
    'pt_use_count',
    'ps_use_count',
    've_use_count',
  ]
  // 音频
  const audioProperties = [
    'type',
    'format',
    'file_size',
    'duration',
    'pt_use_count',
    'ps_use_count',
    've_use_count',
  ]
  // 龙骨
  const keelProperties = ['type', 'file_size', 'pt_use_count', 'ps_use_count']
  // 字体
  const fontProperties = [
    'type',
    'format',
    'file_size',
    'languages',
    'pt_use_count',
    'ps_use_count',
    've_use_count',
  ] // 是否增加适配工具
  // 粒子
  const particleProperties = [
    'type',
    'file_size',
    'realize_method',
    'pt_use_count',
    'ps_use_count',
  ]
  // 花字
  const flowerWordProperties = [
    'type',
    'file_size',
    'flower_word_type',
    'pt_use_count',
    'ps_use_count',
    've_use_count',
  ]
  // 转场
  const transitionProperties = [
    'type',
    'file_size',
    'pt_use_count',
    'ps_use_count',
    've_use_count',
  ]
  // 滤镜
  const filterProperties = ['type', 'file_size', 'pt_use_count', 'ps_use_count']
  // 动画
  const animationProperties = [
    'type',
    'file_size',
    'adapter_resources',
    'cartoon_type',
    'pt_use_count',
    'ps_use_count',
    've_use_count',
  ]

  // 预设
  const presetsProperties = [
    'type',
    'file_size',
    'pt_use_count',
    'ps_use_count',
  ]

  // 模型
  const modelProperties = [
    'type',
    'file_size',
    'skeleton_type',
    'model_basic_info',
    'pt_use_count',
    'ps_use_count',
  ]

  // 动作
  const actionProperties = [
    'type',
    'file_size',
    'skeleton_type',
    'action_basic_info',
    'pt_use_count',
    'ps_use_count',
  ]

  // 全部
  if (val === TabsType.ALL) {
    // 片段是单独的接口,全部内不显示片段数据，可在片段库单独查看
    resourceProperties = resourceInformation.filter(
      (item) => !fragmentProperties.includes(item.prop as string),
    )

    // 视频
  } else if (val === TabsType.VIDEO) {
    resourceProperties = resourceInformation.filter((item) =>
      videoProperties.some((it) => it === item.prop),
    )
    // 图片
  } else if (val === TabsType.PICTURE) {
    resourceProperties = resourceInformation.filter((item) =>
      pictureProperties.some((it) => it === item.prop),
    )
    // 动图
  } else if (val === TabsType.GRAPH) {
    resourceProperties = resourceInformation.filter((item) =>
      graphProperties.some((it) => it === item.prop),
    )
    // 音频
  } else if (val === TabsType.AUDIO) {
    resourceProperties = resourceInformation.filter((item) =>
      audioProperties.some((it) => it === item.prop),
    )
    // 粒子
  } else if (val === TabsType.PARTICLE) {
    resourceProperties = resourceInformation.filter((item) =>
      particleProperties.some((it) => it === item.prop),
    )
    // 字体
  } else if (val === TabsType.FONT) {
    resourceProperties = resourceInformation.filter((item) =>
      fontProperties.some((it) => it === item.prop),
    )
    // 龙骨
  } else if (val === TabsType.KEEL) {
    resourceProperties = resourceInformation.filter((item) =>
      keelProperties.some((it) => it === item.prop),
    )
    // 花字
  } else if (val === TabsType.FLOWERWORD) {
    resourceProperties = resourceInformation.filter((item) =>
      flowerWordProperties.some((it) => it === item.prop),
    )
    // 转场
  } else if (val === TabsType.TRANSITION) {
    resourceProperties = resourceInformation.filter((item) =>
      transitionProperties.some((it) => it === item.prop),
    )
    // 滤镜
  } else if (val === TabsType.FILTER) {
    resourceProperties = resourceInformation.filter((item) =>
      filterProperties.some((it) => it === item.prop),
    )
    // 动画
  } else if (val === TabsType.ANIMATION) {
    resourceProperties = resourceInformation.filter((item) =>
      animationProperties.some((it) => it === item.prop),
    )
    // 预设
  } else if (val === TabsType.PRESETS) {
    resourceProperties = resourceInformation.filter((item) =>
      presetsProperties.some((it) => it === item.prop),
    )
    // 片段
  } else if (val === TabsType.FRAGMENT) {
    resourceProperties = resourceInformation.filter((item) =>
      fragmentProperties.some((it) => it === item.prop),
    )
  } else if (val === TabsType.MODEL) {
    // 模型
    resourceProperties = resourceInformation.filter((item) =>
      modelProperties.some((it) => it === item.prop),
    )
  } else if (val === TabsType.ACTION) {
    // 模型
    resourceProperties = resourceInformation.filter((item) =>
      actionProperties.some((it) => it === item.prop),
    )
  }
  return resourceProperties
}

// 自定义展示列与table
export function tableColumnConFun(
  checkedGroups: CheckedGroupsType,
  resourcesOption: TableColumnType[],
): TableColumnType[] {
  // 基本信息
  const baseProp = dataBaseInformation
    .filter((d: TableColumnType) =>
      checkedGroups.baseGroups.includes(String(d.prop)),
    )
    .map((d: TableColumnType) => ({ ...d }))

  // 资源属性
  const resourceProp = resourcesOption
    .filter((d: TableColumnType) =>
      checkedGroups.resourceGroups.includes(String(d.prop)),
    )
    .map((d: TableColumnType) => ({ ...d }))

  // 资源状态
  const statusProp = dataStatusInformation
    .filter((d: TableColumnType) =>
      checkedGroups.statusGroups.includes(String(d.prop)),
    )
    .map((d: TableColumnType) => ({ ...d }))

  // 资源标签
  const labelProp = dataLabelInformation
    .filter((d: TableColumnType) =>
      checkedGroups.labelGroups.includes(String(d.prop)),
    )
    .map((d: TableColumnType) => ({ ...d }))

  baseProp.splice(2, 0, {
    prop: 'action-cell',
    slot: 'action-cell',
  })

  return [
    {
      prop: 'select-cell',
      slot: 'select-cell',
    },
    ...baseProp,
    ...resourceProp,
    ...statusProp,
    ...labelProp,
  ]
}
